module.exports = __webpack_public_path__ + "static/img/banner_img1.b4cabfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/banner_img1.png
// module id = +trd
// module chunks = 0